<template>
  <!-- Home Section 03 -->
  <div>
    <section class="home-page">
      <div class="row">
        <div class="col col-md-5 col-sm-5 col-5">
          <div class="text_colum animation_colum">
            <h4>Volunteers</h4>
            <p class="animation_button">can change the world.</p>
            <div class="heading_txt">
              <span class="getting_line"></span>
              <b>Getting started is easy.</b>
            </div>
          </div>
        </div>
        <div class="col col-md-7 col-sm-8 col-10" data-aos="fade-left">
          <VueSlickCarousel v-bind="settings" @init="onInitCarousel">
            <a class="navbar-brand nav-item column">
              <img class="logo" src="../assets/img/home_1.jpg" style="width: 100%" />
            </a>
            <a class="navbar-brand nav-item column">
              <img class="logo" src="../assets/img/home_2.jpg" style="width: 100%" />
            </a>
            <a class="navbar-brand nav-item column">
              <img class="logo" src="../assets/img/home_3.jpg" style="width: 100%" />
            </a>
            <a class="navbar-brand nav-item column">
              <img class="logo" src="../assets/img/home_2.jpg" style="width: 100%" />
            </a>
            <template #prevArrow="arrowOption">
              <div class="custom-arrow">
                <span class="slick_index_pre">0{{ arrowOption.currentSlide + 1 }}</span
                >/0{{ arrowOption.slideCount }}
              </div>
            </template>
            <template #nextArrow="">
              <div class="custom-arrow">
                <span class="next_icon_slick"></span
                ><span class="fas_slick_icon"><i class="fas fa-angle-right"></i></span>
              </div>
            </template>
          </VueSlickCarousel>
        </div>
      </div>
    </section>
    <!-- Features Area  v-scrollanimation- v-scrollanimation-left -scrollanimation-right-->
    <section class="content-section-01 home_1">
      <div class>
        <div class="row justify-content-center">
          <div class="col col-xl-4 col-sm-5" data-aos="fade-right">
            <div class="content-img">
              <img src="../assets/img/body_image_1.jpg" alt />
            </div>
          </div>
          <div class="col col-xl-5 col-sm-7" data-aos="fade-left">
            <div class="content-right-content container">
              <h2>
                Do you want to use your time and skills to build a better society and
                country? Apply to learn new skills, share knowledge, make a difference in
                life and become a part of volunteering for the youth of Bangladesh.....
              </h2>
              <div class="row section_3-button">
                <div class="col">
                  <router-link to="/registration"
                    ><button type="submit" class="app-button">
                      Apply Now
                    </button></router-link
                  >
                </div>
                <div class="col">
                  <button type="submit" class="app-button_b" @click="HasLogin()">
                    Log in
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots

//import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "MyComponent",
  components: { VueSlickCarousel },
  data() {
    return {
      show: true,
      settings: {
        arrows: true,
        dots: true,
        focusOnSelect: true,
        touchMove: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        touchThreshold: 5,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: true,
              dots: true,
              focusOnSelect: true,
              touchMove: true,
              infinite: true,
              speed: 500,
            },
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    HasLogin() {
      this.$root.loginFormShow = !this.$root.loginFormShow;
    },
    onInitCarousel(event, slick) {
      console.log("handleslick", event, slick);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "/assets/css/slick-theme.css";
.app-button {
  background-color: #07cddb;
  border-radius: 28px;
  width: 140px;
  display: inline-block;
  line-height: 40px;
  font-weight: 500;
}
.text_colum h4::before {
  font-size: 46px;
  opacity: 0;
}
.content-section-01 {
  padding: 20px 0 80px;
}
.home-page {
  overflow: hidden;
  padding: 80px 0px;
}
.slick_index_pre {
  color: #07cddb;
  font-size: 15px;
}
.next_icon_slick {
  width: 50px;
  height: 1px;
  background: #565656;
}
.fas_slick_icon {
  color: #07cddb;
  padding-top: 7.5px;
  position: absolute;
  padding-left: 4px;
}
.app-button_b {
  border-radius: 28px;
  width: 140px;
  display: inline-block;
  line-height: 40px;
  font-weight: 500;
}
.slick-dots {
  position: absolute;
  bottom: -25px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  color: #fff;
}
.slick-slider {
  position: relative;
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
  width: 110%;
}
.slick-slider li {
  position: relative;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
  float: left;
}
.slick-dots {
  position: absolute;
  bottom: -25px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: left;
}
.slick-slider li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 20px;
  height: 20px;
  padding: 5px;
  cursor: pointer;
  color: red !important;
  border: 0;
  outline: none;
  background: red !important;
}

.heading_txt .getting_line {
  width: 50px;
  height: 3px;
  background: #00dcff;
  margin-top: 20px;
  position: absolute;
}

.text_colum {
  padding-top: 280px;
  padding-left: 190px;
}
.text_colum h4 {
  font-size: 46px;
}
.text_colum p {
  font-size: 32px;
  padding-top: 15px;
}
.section_3-button {
  width: 430px;
  padding-top: 30px;
  margin-left: auto;
  text-align: center;
  justify-content: center;
  margin-right: auto;
}
.text_colum b {
  font-size: 26px;
  color: #00dcff;
  cursor: pointer;
  padding-left: 80px;
}
@media (max-width: 1601px) {
  .text_colum {
    padding-top: 200px;
    padding-left: 100px;
  }
}
@media (max-width: 1200px) {
  .text_colum {
    padding-top: 120px;
    padding-left: 70px;
  }
  .text_colum h4 {
    font-size: 46px;
  }
  .text_colum p {
    font-size: 32px;
    padding-top: 15px;
  }
  .section_3-button {
    width: 430px;
    padding-top: 30px;
    margin-left: auto;
    text-align: center;
    justify-content: center;
    margin-right: auto;
  }
  .text_colum b {
    font-size: 24px;
    color: #00dcff;
    cursor: pointer;
    padding-left: 60px;
  }
}
@media (max-width: 1024px) {
  .text_colum {
    padding-top: 180px;
    padding-left: 50px;
  }
  .text_colum h4 {
    font-size: 34px;
  }
  .text_colum p {
    font-size: 24px;
    padding-top: 15px;
  }
  .section_3-button {
    width: 430px;
    padding-top: 30px;
    margin-left: auto;
    text-align: center;
    justify-content: center;
    margin-right: auto;
  }
  .text_colum b {
    font-size: 22px;
    color: #00dcff;
    cursor: pointer;
    padding-left: 60px;
  }
  .heading_txt .getting_line {
    width: 40px;
    height: 2.5px;
    background: #00dcff;
    margin-top: 20px;
    position: absolute;
  }
}
@media (max-width: 920px) {
  .section_3-button {
    width: 430px;
    padding-top: 30px;
    margin-left: auto;
    text-align: center;
    justify-content: center;
    margin-right: auto;
  }
  .text_colum h4 {
    font-size: 32px;
  }
  .content-right-content {
    width: 95%;
    margin-top: -10%;
  }
  .text_colum p {
    font-size: 22px;
    padding-top: 15px;
  }
  .text_colum b {
    font-size: 18px;
    color: #00dcff;
    cursor: pointer;
    padding-left: 40px;
  }
  .heading_txt .getting_line {
    width: 30px;
    height: 2.5px;
    background: #00dcff;
    margin-top: 14px;
    position: absolute;
  }
}
@media (max-width: 768px) {
  .col {
    -ms-flex-preferred-size: 0;
    flex-basis: auto;
  }
  .section_3-button .col {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    width: 10px;
    margin-left: auto;
    text-align: center;
    justify-content: center;
    margin-right: auto;
  }
  .home_1 .col-sm-5 {
    max-width: 100%;
  }
  .home_1 .col-sm-7 {
    max-width: 100%;
  }
}

.subscribe_button_b {
  color: #fff;
  font-size: 22px;
}
.email_sent_feild {
  padding: 15px 0px 20px 0px;
  margin-left: -15px;
}
.email_sent_feild input {
  padding: 25px 10px;
  border-radius: 8px;
}
.d-md-block {
  position: absolute;
  left: 8%;
}
/* Create two equal columns that floats next to each other */
.column {
  float: left;
  width: 35%;
  padding: 10px;
  height: auto;
}
.column1 {
  float: left;
  width: 65%;
  padding: 10px;
  height: auto;
}

.home-page .column .text_colum {
  padding-left: 35%;
}
.home-page .column .text_colum h4 {
  margin-top: 40%;
  font-size: 44px;
}
.home-page .column .text_colum p {
  margin-top: 2%;
  font-weight: 500;
  font-size: 32px;
}
.home-page .column .text_colum b {
  font-weight: 400;
  color: #07cddb;
  font-size: 24px;
}
@media screen and (max-width: 767px) {
  .column {
    float: left;
    width: 100%;
    height: auto;
    padding: 10px;
  }
  .column1 {
    float: left;
    width: 100%;
    padding: 5px;
    height: auto;
    margin-left: 20px;
  }
  /* Clear floats after the columns */
  .row:after {
    content: "";
    display: table;
    clear: both;
  }
  .content-right-content,
  .content-left-content {
    padding-top: 0px;
    text-align: left;
    padding-left: 25px;
    padding-right: 25px;
  }
  .text_colum {
    padding-top: 50px;
    padding-left: 50px;
  }
  .content-right-content,
  .content-left-content {
    padding-top: 0px;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
  }
  .content-right-content {
    width: 100%;
    margin-top: -10%;
  }
  .section_3-button {
    width: 330px;
    padding-top: 30px;
    margin-left: auto;
    text-align: center;
    justify-content: center;
    margin-right: auto;
  }
}
@media screen and (max-width: 480px) {
  .home-page .column h4 {
    margin-top: 10%;
    padding-left: 0%;
    font-size: 32px;
    text-align: center;
  }
  .home-page .column p {
    margin-top: 2%;
    padding-left: 0%;
    padding-bottom: 20px;
    font-size: 24px;
    text-align: center;
  }
  .home-page {
    overflow: hidden;
    padding: 40px 0px 25px 0px;
  }
  .section_3-button {
    padding-top: 10px;
  }
  .content-section-01 {
    padding: 20px 0 40px;
  }
  .content-right-content h2,
  .content-left-content h2 {
    width: 100%;
  }
  .content-right-content h2,
  .content-left-content h2 {
    font-size: 16px;
  }
}
@media screen and (max-width: 400px) {
  .section_3-button {
    margin-left: 8px;
  }
}
@media screen and (max-width: 360px) {
  .section_3-button {
    margin-left: 0px;
  }
}
@media screen and (max-width: 320px) {
  .section_3-button {
    margin-left: -18px;
  }
}
</style>
